export const GET_ALL_DROPS = "GET_ALL_DROPS";
export const UPDATE_DROP_TARGET = "UPDATE_DROP_TARGET";
export const UPDATE_ACTIVE_DROP = "UPDATE_ACTIVE_DROP";
export const GET_TARGET_TYPE = "GET_TARGET_TYPE";
export const GET_TARGET_TYPE_HOVER = "GET_TARGET_TYPE_HOVER";
export const GET_SAVED_DROP_TARGETS = "GET_SAVED_DROP_TARGETS";
export  const REMOVE_LINE = "REMOVE_LINE";

export const get_all_drops = (amount) => {

    let items = [];

    for(var i = 0; i < amount; i++)
    {
        let obj = {
            "active": false,
            items: [
                {
                    types: 'top',
                    item: false,
                },
                {
                    types: 'right',
                    item: false,
                },
                {
                    types: 'left',
                    item: false,
                },
                {
                    types: 'bottom',
                    item: false,
                }
            ]
            // item: false,
        }
        items.push(obj);
    }

    return {
        type: GET_ALL_DROPS,
        items: items,
    }
}
export const canDrop = (item, index) => {
    
}
export const update_active = (active, index) => {
    return {
        type: UPDATE_DROP_TARGET,
        index: index,
        active: active
    }
}
export const update_drop_target = (item, index, child ) => {
    return {
        type: UPDATE_DROP_TARGET,
        index: index,
        childIndex: child,
        item: item
    }

}
export const getTargetType = (item, rotation) => {

    return {
        type: GET_TARGET_TYPE,
        item:item,
        rotation: rotation
    }

}

export const getHoverType = (item) => {
    return {
        type: GET_TARGET_TYPE_HOVER,
        item: item
    }

}

export const addSavedDataToDropelements = (data) => {

    return {
        type:GET_SAVED_DROP_TARGETS,
        data:data
    }

}
export const removeItem = (index, childIndex) => {
    return {
        type: REMOVE_LINE,
        index:index,
        childIndex
        
    }
}

export const resetStorage = () => {
    return(dispatch) => {
        localStorage.removeItem('dropelements-weland');
        localStorage.removeItem('dragdrop-welandutemiljo');
        dispatch(get_all_drops(196));
    }
}
export const checkCanDrop = (drop, item, mainIndex) => {
    return(dispatch) => {
        let checking = drop.items.map((value, index) => {
            if(mainIndex > 0)
            {
                return true;
            }
            console.log(mainIndex);
            return false;
        }) 
        return checking;
    }
    /* let drop_type = item.type;
    const mainindex = mainIndex;
        let checking = drop[mainindex].items.map((value, index) => {
            if(mainindex > 0)
            {
                console.log("/////");
                return true;
            }else {
                return false;
            }
            
        })
    return(dispatch) => {
        if(checking)
        {
            return true;
        }
        return false;
    } */
}


// WEBPACK FOOTER //
// ./src/Services/Drop/action.js